<div #userContainer [style.min-width.px]="minWidth" class="user-container">
  @if (currentUser && isLargeScreen()) {
    <div class="information-container">
      <span class="expiration-timer">{{ expirationTimeInMinutes }} min</span>
      <span class="department">Session expiration in</span>
    </div>
  }

  @if (currentUser && currentUser.userData) {
    <div class="avatar" sag-ui-avatar-base (click)="openDialog()">
      <div sag-ui-avatar>{{ currentUser.userData.firstName[0] }}{{ currentUser.userData.lastName[0] }}</div>
      @if (isLargeScreen()) {
        <div>
          <div sag-ui-avatar-name>{{ currentUser.userData.fullName }}</div>
          <div sag-ui-avatar-org>{{ currentUser.userData.department }}</div>
        </div>
      }
    </div>
  }
  <div>
    @if (isFaqModuleActive) {
      <sag-ui-button color="tertiary" [icon]="'circle-help'" (click)="openFaq.emit()"> FAQ </sag-ui-button>
    }
    @if (isLanguageSelectionAvailable) {
      <app-language-toggle />
    }
    <app-communication #communication />
    <sag-ui-button color="tertiary" [square]="true" [icon]="isDarkMode ? 'moon' : 'sun'" (click)="switchTheme()"></sag-ui-button>
  </div>
</div>
